import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Copy, Share2 } from "lucide-react";
import { api, extractError } from "@/lib/api";

export default function Invitations() {
  const [referral, setReferral] = useState(null);
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/referrals/me")
      .then(({ data }) => setReferral(data))
      .catch((e) => setError(extractError(e, "Impossibile preparare il link di invito.")));
  }, []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(referral.link);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2500);
    } catch {
      setError("Copia il link manualmente dal campo qui sotto.");
    }
  };

  const share = async () => {
    if (navigator.share) {
      await navigator.share({ title: "NOVAXLOVE", text: "Ti invito a scoprire NOVAXLOVE", url: referral.link });
    } else {
      await copy();
    }
  };

  return (
    <div className="max-w-3xl" data-testid="invitations-page">
      <p className="nvl-overline" style={{ color: "hsl(var(--nvl-accent))" }}>Inviti</p>
      <h1 className="mt-3 text-4xl md:text-5xl">Invita una persona</h1>
      <p className="mt-3 text-sm" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
        Condividi il tuo link personale: sapremo quante persone si sono iscritte grazie al tuo invito.
      </p>

      <div className="mt-8 nvl-card p-6">
        {error ? <p className="text-sm" style={{ color: "hsl(var(--destructive))" }}>{error}</p> : null}
        {!referral && !error ? <p className="text-sm" style={{ color: "hsl(var(--nvl-ink-soft))" }}>Preparazione del tuo link…</p> : null}
        {referral ? <>
          <p className="text-xs uppercase tracking-widest" style={{ color: "hsl(var(--nvl-ink-soft))" }}>Il tuo link</p>
          <input readOnly value={referral.link} className="nvl-input mt-2 w-full text-sm" data-testid="invitation-link" />
          <div className="mt-4 flex flex-wrap gap-3">
            <button type="button" onClick={copy} className="nvl-btn nvl-btn-outline" data-testid="invitation-copy">
              <Copy size={15} className="mr-2" /> {copied ? "Copiato" : "Copia link"}
            </button>
            <button type="button" onClick={share} className="nvl-btn nvl-btn-primary" data-testid="invitation-share">
              <Share2 size={15} className="mr-2" /> Condividi
            </button>
          </div>
          <p className="mt-7 text-sm"><strong>{referral.signups}</strong> iscrizioni attribuite al tuo invito.</p>
        </> : null}
      </div>
      <Link to="/app/settings" className="inline-block mt-6 text-sm underline">← Impostazioni</Link>
    </div>
  );
}
